"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const HelperUtils_1 = require("utils/HelperUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const PaginationModule_1 = __importDefault(require("components/shared/PaginationModule/PaginationModule"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const ResultContentTable = ({ users, scoreAspects, configResult, onClickRow, currentPage, prevPage, nextPage, hasMore, isPerfCategory, isLoading }) => {
    const [customHeaders, setCustomHeaders] = (0, react_1.useState)([]);
    const { finalResultVisible, finalPerformanceCategoryResultVisible } = configResult || {};
    const defaultHeaders = [
        { name: 'No', widthClass: 'w-[64px]' },
        { name: 'Reviewee', widthClass: 'w-[240px]', grow: true }
    ];
    const setCustomHeadersAndColumns = () => {
        const tempHeaders = scoreAspects === null || scoreAspects === void 0 ? void 0 : scoreAspects.map((_a) => {
            var { idAspect } = _a, keys = __rest(_a, ["idAspect"]);
            return keys;
        });
        if (finalResultVisible) {
            tempHeaders.push({ name: 'Final', widthClass: 'w-[200px]' });
        }
        if (finalPerformanceCategoryResultVisible) {
            tempHeaders.push({
                name: 'Performance Category',
                widthClass: 'w-[150px]'
            });
        }
        setCustomHeaders(tempHeaders);
    };
    (0, react_1.useEffect)(() => {
        setCustomHeadersAndColumns();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Table_1.default, { headers: [...defaultHeaders, ...customHeaders], fixedLeftCount: 2, withHideColumn: true }, isLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (users === null || users === void 0 ? void 0 : users.map((user, index) => {
            var _a, _b;
            return (react_1.default.createElement(Table_1.default.Row, { key: `table-row-${index}`, onClick: (e) => onClickRow(e, user), tooltip: {
                    show: true,
                    text: (0, HelperUtils_1.getObjectiveLocale)('Click to view review')
                }, dataCy: `table-row-${index}` },
                react_1.default.createElement(Table_1.default.Column, { key: "table-column-0", dataCy: "table-column-0" }, (currentPage - 1) * 10 + (index + 1)),
                react_1.default.createElement(Table_1.default.Column, { key: "table-column-1", dataCy: "table-column-1" },
                    react_1.default.createElement(ProfileType_1.default, { user: user, title: user === null || user === void 0 ? void 0 : user.name, subtitle: (0, HelperUtils_1.getExtraInformation)(user === null || user === void 0 ? void 0 : user.title, user === null || user === void 0 ? void 0 : user.subtitle), size: 32, titleClassName: "typography-h400 text-n-800", subtitleClassName: "typography-h100 text-n-800" })),
                scoreAspects &&
                    (scoreAspects === null || scoreAspects === void 0 ? void 0 : scoreAspects.map((scoreAspect, index) => {
                        var _a, _b;
                        return (react_1.default.createElement(Table_1.default.Column, { key: `table-column-${index + 2}`, dataCy: `table-column-${index + 2}` },
                            react_1.default.createElement(ScoreColumn, { scoreData: (_b = (_a = user === null || user === void 0 ? void 0 : user.score) === null || _a === void 0 ? void 0 : _a.scoreAspects) === null || _b === void 0 ? void 0 : _b.find((val) => (val === null || val === void 0 ? void 0 : val.id) === (scoreAspect === null || scoreAspect === void 0 ? void 0 : scoreAspect.idAspect)) })));
                    })),
                finalResultVisible && (react_1.default.createElement(Table_1.default.Column, { key: `table-column-${2 + (scoreAspects ? scoreAspects === null || scoreAspects === void 0 ? void 0 : scoreAspects.length : 0)}`, dataCy: `table-column-${2 + (scoreAspects ? scoreAspects === null || scoreAspects === void 0 ? void 0 : scoreAspects.length : 0)}` },
                    react_1.default.createElement(ScoreColumn, { scoreData: (_a = user === null || user === void 0 ? void 0 : user.score) === null || _a === void 0 ? void 0 : _a.final }))),
                finalPerformanceCategoryResultVisible && (react_1.default.createElement(Table_1.default.Column, { key: `table-column-${(customHeaders === null || customHeaders === void 0 ? void 0 : customHeaders.length) + 1}`, dataCy: `table-column-${(customHeaders === null || customHeaders === void 0 ? void 0 : customHeaders.length) + 1}` },
                    react_1.default.createElement(ScoreColumn, { scoreData: (_b = user === null || user === void 0 ? void 0 : user.score) === null || _b === void 0 ? void 0 : _b.finalPerformanceCategory, isPerfCategory: isPerfCategory, useCategoryScore: true })))));
        }))),
        react_1.default.createElement("div", { className: "flex justify-end w-full mt-[12px] mb-[40px]" },
            react_1.default.createElement(PaginationModule_1.default, { pageNumber: currentPage, handleNext: nextPage, handlePrev: prevPage, hasMore: hasMore }))));
};
const ScoreColumn = ({ scoreData, isPerfCategory }) => {
    const { statusName, statusColorHex, score, performanceCategory, showOption } = scoreData || {};
    const getScoreValue = () => {
        if (isPerfCategory && performanceCategory) {
            return performanceCategory;
        }
        return score;
    };
    const scoreValue = getScoreValue();
    return (react_1.default.createElement("div", { className: "flex flex-col justify-center" },
        showOption !== 'score_only' && !isPerfCategory && (react_1.default.createElement(TruncateParagraph_1.default, { className: `typography-h100 ${statusColorHex ? '' : 'text-n-800'}`, textStyle: statusColorHex ? { color: `#${statusColorHex}` } : {} }, statusName || '')),
        showOption !== 'label_only' && scoreValue && (react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, scoreValue % 1 !== 0 && (0, isNumber_1.default)(scoreValue)
            ? scoreValue.toFixed(2)
            : scoreValue))));
};
exports.default = ResultContentTable;
